import Vue from 'vue';
import Router from 'vue-router';
import Login from '../screens/login';

import UserGroups from '../screens/userGroups';
import CreateUserGroup from '../screens/userGroups/create';
import UpdateUserGroup from '../screens/userGroups/update';

import Templates from '../screens/templates';
import CreateTemplate from '../screens/templates/create';
import UpdateTemplate from '../screens/templates/update';

import Notifications from '../screens/notifications';
import CreateNotification from '../screens/notifications/create';
import UpdateNotification from '../screens/notifications/update';
import NotificationViewer from '../screens/notifications/viewer';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    // Login paths
    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    // User Groups paths
    {
      path: '/userGroups',
      name: 'UserGroups',
      component: UserGroups,
      meta: { requiresAuth: true }
    },
    {
      path: '/userGroups/create',
      name: 'CreateUserGroup',
      component: CreateUserGroup,
      meta: { requiresAuth: true }
    },
    {
      path: '/userGroups/update/:id',
      name: 'UpdateUserGroup',
      component: UpdateUserGroup,
      props: true,
      meta: { requiresAuth: true }
    },

    // Templates paths
    {
      path: '/templates',
      name: 'Templates',
      component: Templates,
      meta: { requiresAuth: true }
    },
    {
      path: '/templates/create',
      name: 'CreateTemplate',
      component: CreateTemplate,
      meta: { requiresAuth: true }
    },
    {
      path: '/templates/update/:id',
      name: 'UpdateTemplate',
      component: UpdateTemplate,
      props: true,
      meta: { requiresAuth: true }
    },

    // Notifications paths
    {
      path: '/notifications',
      name: 'Notifications',
      component: Notifications,
      meta: { requiresAuth: true }
    },
    {
      path: '/notifications/create',
      name: 'CreateNotification',
      component: CreateNotification,
      meta: { requiresAuth: true }
    },
    {
      path: '/notifications/update/:id',
      name: 'UpdateNotification',
      component: UpdateNotification,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/notifications/view/:id',
      name: 'NotificationViewer',
      component: NotificationViewer,
      props: true,
      meta: { requiresAuth: true }
    },

    // 404 paths
    {
      path: '*',
      redirect: '/login'
    }
  ]
});

router.beforeEach((to, from, next) => {
  // Vérification de l'autorisation d'entrée pour chaque route
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('TOKEN') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else next();
  } else next();
});

export default router;
